module.exports = __webpack_public_path__ + "img/HZ-S4049.3670e5b4.jpg";